import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrapper-count-lots" }
const _hoisted_2 = { class: "count-total-lots" }
const _hoisted_3 = { class: "list-lots" }
const _hoisted_4 = { class: "title-lot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-title" }, "Total lots", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString($setup.sumProgressItems), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["progress", { hidden: !$setup.sumProgressItems }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "progress-item",
          key: index,
          style: _normalizeStyle({ background: item.color, width: $setup.getProgressItemWidth(item.count), height: '100%' })
        }, null, 4))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "wrapper-list-lot",
          key: index
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: "circle",
              style: _normalizeStyle({ backgroundColor: item.color })
            }, null, 4),
            _createElementVNode("span", _hoisted_4, _toDisplayString(index === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : index), 1)
          ]),
          _createElementVNode("div", {
            class: "numerical-value",
            style: _normalizeStyle({ color: item.color })
          }, _toDisplayString(item.count), 5)
        ]))
      }), 128))
    ])
  ]))
}